import Field from "@/components/Field";
import PayrollDepartmentSelect from "@/components/PayrollDepartmentSelect";
import StoreSelect from "@/components/StoreSelect";
import { isRequired } from "@/lib/form";
import { writeDepartmentBasedAssignments } from "@/schemas/departmentBasedAssignments";
import { useTranslation } from "react-i18next";

const schema = writeDepartmentBasedAssignments;

export const ContractorsAssignmentsDepartmentBasedFields = () => {
  const { t } = useTranslation();

  return (
    <>
      <Field
        name="store_id"
        label={t("contractorsAssignments.fields.store_id")}
        required={isRequired(schema.shape.store_id)}
        render={({ field }) => (
          <StoreSelect
            {...field}
            className="w-80"
            loading="eager"
            inDialog
            queryParams={{ project_dependency: "department" }}
          />
        )}
      />
      <Field
        name="payroll_department_id"
        label={t("contractorsAssignments.fields.payroll_department_id")}
        required={
          "payroll_department_id" in schema.shape &&
          isRequired(schema.shape.payroll_department_id)
        }
        render={({ field }) => (
          <PayrollDepartmentSelect
            {...field}
            className="w-80"
            loading="eager"
            inDialog
          />
        )}
      />
    </>
  );
};
